import { KitchenSinkRoute, RouteSlotInput } from '@luks/ui';

export const mapWallsIo = (
  input: WallsIoFragment | null,
): RouteSlotInput<typeof KitchenSinkRoute, 'body', 'WallsIo'> => ({
  key: 'WallsIo',
  input: {
    title: input?.title,
  },
});
